import { validator } from "@/utils/validator";

export const residencePeriodSchema = validator.object().shape({
  residencePeriod: validator.string().trim().emptyToNull().label("在留期間").notRequired(),
});

export const masterDataCreateResidenceStatusSchema = validator.object().shape({
  residenceStatus: validator.string().trim().emptyToNull().label("在留資格").required(),
  residencePeriods: validator.array().of(residencePeriodSchema).label("residencePeriods").required(),
});

export const masterDataUpdateResidenceStatusSchema = validator.object().shape({
  residenceStatus: validator.string().trim().emptyToNull().label("在留資格").required(),
});
